import React, { useEffect, useState } from "react";
import { TableRow, TableCell, Switch, IconButton } from "@mui/material";
import IosSwitchBtn from "../../../../Component/DigitalMarketing/IosSwitchbtn";
import dele from "../../../../assets/DigitalMarketing/image/delete.svg";
import eye from "../../../../assets/DigitalMarketing/image/visibility.svg";
import edit from "../../../../assets/DigitalMarketing/image/edit.svg";
import useDeleteBox from "../../../../hooks/digitalMarketing/useDeleteBox";
import AlertDialog from "../../../../Component/DigitalMarketing/deleteConfirmation";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import {
  useDeleteMyLabMutation,
  useUpdateLabStatusMutation,
} from "../../../../Service/LabManagement";
import { formatDate } from "../../PotentialLeads/Utils/TableHeadlist";

const TableLists = ({
  order,
  setShow,
  setUpdateData,
  setView,
  list,
  deleted,
  setDeleted,
  refetch,
}) => {
  const handleUpdate = (data: any) => {
    setView(false);
    console.log(data);
    setShow(true);
    setUpdateData(data);
  };
  const { open, message, openSnackBar, type } = useSnackbar();
  const [deleteLab] = useDeleteMyLabMutation();
  const [updateLabStatus] = useUpdateLabStatusMutation();

  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();

  const handleStatusChange = (index, id) => async (event) => {
    const isActive = event.target.checked;
    try {
      await updateLabStatus({ id, activeStatus: isActive ? 1 : 0 }).unwrap();
      openSnackBar(
        `Lab status updated to ${isActive ? "Active" : "Inactive"}`,
        "success"
      );
      const newCheckedStates = [...checkedStates];
      newCheckedStates[index] = isActive;
      setCheckedStates(newCheckedStates);
    } catch (err) {
      openSnackBar("Failed to update status", "error");
    }
  };

  const Delete = async (bool) => {
    if (bool) {
      try {
        const payload = await deleteLab(deleteId).unwrap();
        openSnackBar("Deleted successfully");
        console.log("deleted");
        setDeleted(true);
        refetch();
      } catch (err: any) {
        openSnackBar(err.data.error, "error");
      }
    }
    openDelete("Are you sure you want to delete this Lab?", false, null);
  };
  const handleView = (data: any) => {
    setView(true);
    setShow(true);
    setUpdateData(data);
  };
  const [checkedStates, setCheckedStates] = useState([]);

  useEffect(() => {
    if (list?.data) {
      setCheckedStates(
        list.data.map((procedure) => procedure?.activeStatus === 1)
      );
    }
  }, [list]);
  return (
    <>
      <AlertDialog open={open1} message={message1} deleteBranches={Delete} />

      {list?.data?.map((row, index) => (
        <TableRow key={index}>
          <TableCell align="left">{index + 1}</TableCell>
          <TableCell align="left">{row.labName}</TableCell>
          <TableCell align="left">{row.email}</TableCell>
          <TableCell align="left">{row.phone}</TableCell>
          <TableCell align="left">{formatDate(row.createdAt)}</TableCell>
          <TableCell align="left">
            <IosSwitchBtn
              onChange={handleStatusChange(index, row.id)}
              checked={
                checkedStates[index] !== undefined
                  ? checkedStates[index]
                  : false
              }
              label={checkedStates[index] ? "Active" : "Inactive"}
            />
          </TableCell>
          <TableCell align="left">
            <img
              src={edit}
              alt="edit"
              className="blue-c action-icon cursur me-2"
              onClick={() => handleUpdate(row)}
            />
            <img
              src={eye}
              alt="view"
              className="blue-c action-icon cursor"
              onClick={() => handleView(row)}
            />
            &nbsp;&nbsp;&nbsp;
            <img
              src={dele}
              alt="delete"
              className="delete-icon cursor action-icon"
              onClick={() =>
                openDelete(
                  "Are you sure you want to delete this Lab?",
                  true,
                  row.id
                )
              }
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default TableLists;
